export default function initCityToggle() {
    let city = document.querySelector(".city")
    if (!city) return

    let citySelect = document.querySelector(".city-select")

    city.addEventListener("click", () => {
        if (body.classList.contains("city-select-opened")) {
            document.removeEventListener("click", outsideEvtListener)
        } else {
            setTimeout(() => {
                document.addEventListener("click", outsideEvtListener)
            })
        }
        city.classList.toggle("js__opened")
        citySelect.classList.toggle("js__opened")
        body.classList.toggle("city-select-opened")
    })

    function outsideEvtListener(evt) {
        if (evt.target === citySelect || citySelect.contains(evt.target)) return
        city.classList.remove("js__opened")
        citySelect.classList.remove("js__opened")
        body.classList.remove("city-select-opened")
        document.removeEventListener("click", outsideEvtListener)
    }

    let citySelectClose = document.querySelector(".city-select__close")
    if (!citySelectClose) return
    citySelectClose.addEventListener("click", () => {
        city.classList.remove("js__opened")
        citySelect.classList.remove("js__opened")
        body.classList.remove("city-select-opened")
        document.removeEventListener("click", outsideEvtListener)
    })
}